/**
 * A wrapper for ES function Object.entries() which improves typing such that the "key" type of the returned
 * [key, value] tuples is correctly inferred from the actual keys being used by the given object.
 *
 * Example:
 * getObjectEntries({ a: 10, b: 20 }) satisfies Array<['a' | 'b', number]>;
 */
export function getObjectEntries<K extends string, V>(object: Record<K, V>): [K, V][];
export function getObjectEntries<K extends string, V>(object: Partial<Record<K, V>>): [K, V | undefined][];
export function getObjectEntries<K extends string, V>(
  object: Record<K, V> | Partial<Record<K, V>>,
): [K, V | undefined][] {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- strengthens lose ES typing
  return Object.entries(object) as [K, V | undefined][];
}
